import { Box, Icon, IconButton } from "@chakra-ui/react";
import React from "react";
import { IoCartOutline } from "react-icons/io5";
import Colors from "../../assets/colors/Colors";

const GrubCartButton = ({itemCount = 0,onClick}) => {
  return (
    <IconButton
      icon={
        <Box position="relative">
          <Icon as={IoCartOutline} display="flex"
            justifyContent="center"
            alignItems="center" fontSize={{ base: "1.31rem", md: "3.30rem" }} color={Colors.loginAuthBackground} />
          <Box
            position="absolute"
            top={{ base: "-0.8rem", md: "-1.2rem" }}
            right={{ base: "-1.1rem", md: "-1.2rem" }}
            bg={Colors.grubBackgroundCart}
            color={Colors.loginAuthBackground}
            borderRadius="50%"
            width={{ base: "1.2rem", md: "1.8rem" }}
            height={{ base: "1.2rem", md: "1.8rem" }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            fontSize="0.9rem"
          >
            {itemCount}
          </Box>
        </Box>
      }
      bg={Colors.posTextInfo}
      aria-label="Cart"
      position="fixed"
      bottom={{ base: "2.5rem", md: "4.6rem" }}
      right={{ base: "2rem", md: "5rem" }}
      borderRadius="50%"
      width={{ base: "2.5rem", md: "5.19rem" }}
      height={{ base: "2.5rem", md: "5.19rem" }}
      onClick={onClick}
    />
  );
};

export default GrubCartButton;
